export default __webpack_public_path__ + "static/media/Documents.90325646.svg";